import { Controller } from 'stimulus';
import { BEFORE_CONNECT } from '../constants';

const REGEX = /\d+(?!.*\d+)/;

function updateField(field, id) {
  field.id = field.id.replace(REGEX, id); // eslint-disable-line no-param-reassign
  field.name = field.name.replace(REGEX, id); // eslint-disable-line no-param-reassign
}

function updateLabel(label, id) {
  label.setAttribute('for', label.getAttribute('for').replace(REGEX, id));
}

export default class extends Controller {
  static targets = ['destroyed', 'cleanup'];

  connect() {
    if (this.destroyedTarget.checked) {
      this.toggle(true);
    }
    this.beforeConnect();
  }

  fieldTargets() {
    return Array.from(this.element.querySelectorAll('input,select,textarea,button'));
  }

  fieldTarget() {
    return this.fieldTargets().find((field) => field.name);
  }

  labelTargets() {
    return Array.from(this.element.querySelectorAll('label'));
  }

  fix(id) {
    this.fieldTargets().forEach((field) => {
      updateField(field, id);
    });
    this.labelTargets().forEach((label) => {
      updateLabel(label, id);
    });
  }

  get id() {
    const { name } = this.fieldTarget();
    const arr = name.match(REGEX);
    if (!arr) {
      return -1;
    }
    return Number(arr[0]);
  }

  toggle(bool) {
    this.element.classList.toggle('hidden', bool);
    if (bool && this.hasCleanupTarget) {
      this.cleanupTarget.innerHTML = '';
    }
  }

  destroy(e) {
    this.toggle(e.target.checked);
  }

  beforeConnect() {
    this.element.dispatchEvent(new Event(BEFORE_CONNECT));
  }
}
